import {Card, Divider, Typography, Menu, Button, Row, Col, DatePicker, Select} from "antd";
import React, {useEffect, useState} from "react";
import ApplicationTable, {DataType} from "@modules/Recruiting/Interview/ApplicationTable";
import { useNavigate } from "react-router-dom";
import { CloseSquareOutlined, FolderOpenOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import api from "../services/api";
import './Submission.scss';

const { Title } = Typography;

type SubmissionProps = {
	title: string;
};

const Submission = (props: SubmissionProps) => {
	const [fetchApplication, setFetchApplication] = useState<DataType[]>([]);
	const [requestCurrentPage, setRequestCurrentPage] = useState<number>(1);

	const { title } = props;

	const {RangePicker} = DatePicker;
	const dateFormat = 'YYYY-MM-DD';
	const firstDayOfYear = dayjs().startOf('year');
	const today = dayjs();
	const [date, setDate] = useState<string[]>([
		firstDayOfYear.format(dateFormat),
		today.format(dateFormat),
	]);
	const [status, setStatus] = useState<string>('');
	const [postName, setPostName] = useState<string>('');
	const [department, setDepartment] = useState<string>('');
	const [responsibleRecruiter, setResponsibleRecruiter] = useState<string>('');
	const [chief, setChief] = useState<string>('');

	const [departmentsSelect, setDepartmentsSelect] = useState<{value: string, label: string}[]>([]);
	const [postNamesSelect, setPostNamesSelect] = useState<{value: string, label: string}[]>([]);
	// const [recruitersSelect, setRecruitersSelect] = useState<{value: string, label: string}[]>([]);
	const [chiefSelect, setChiefSelect] = useState<{value: string, label: string}[]>([]);

	const getFiltered = async () => {
		const startDate = date[0];
		const endDate = date[1];
		const { data } = await api.getFilteredApplications(status, postName, startDate, endDate, department, responsibleRecruiter, chief);
		return data?.data?.active;
	};

	const getFilters = async () => {
		const data = await api.getFilterSettings();
		return data?.data;
	};

	const downloadFile = async () => {
		const startDate = date[0];
		const endDate = date[1];
		const { data } = await api.getExport(status, postName, startDate, endDate, department, responsibleRecruiter, chief);
		const downloadUrl = window.URL.createObjectURL(new Blob([data]));
		const link = document.createElement('a');
		link.href = downloadUrl;
		link.setAttribute('download', 'Отчет по заявкам.xlsx');
		link.click();
		link.remove();
	};

	const handleChangeDatePicker = (date: any, dateString: string[]): void => {
		if (date === null) {
			setDate([
				firstDayOfYear.format(dateFormat),
				today.format(dateFormat),
			]);
			return;
		}
		setDate(dateString);
	};

	const handleStatusChange = (value: string) => {
		setStatus(value);
	};

	const handlePostNameChange = (value: string) => {
		setPostName(value);
	};

	const handleDepartmentChange = (value: string) => {
		setDepartment(value);
	};

	// const handleRecruiterChange = (value: string) => {
	// 	setResponsibleRecruiter(value);
	// };
	const handleChiefChange = (value: string) => {
		setChief(value);
	};

	const handleFilter = () => {
		getFiltered().then((values) => setFetchApplication(values));
	};


	const navigate = useNavigate();

	useEffect(() => {
		getFiltered().then((values) => setFetchApplication(values));
	}, []);

	useEffect(() => {
		document.title = title;
	}, [title]);

	useEffect(() => {
		getFilters().then((values) => {
			const departmentsData = values.department_to;
			const departments = departmentsData.map((element) => ({value: element?.id, label: element?.full_name}));
			setDepartmentsSelect(departments);

			const positionsData = values.name_of_post_id;
			const positions = positionsData.map((element) => ({value: element?.id, label: element?.full_name}));
			setPostNamesSelect(positions);

			// const recruitersData = values.responsible_recruiter;
			// const recruiters = recruitersData.map((element) => ({value: element?.id, label: element?.client_info?.full_name}));
			// setRecruitersSelect(recruiters);
			const chiefsData = values.chiefs;
			const chiefs = chiefsData.map((element) => ({value: element?.id, label: element?.client_info?.full_name}));
			setChiefSelect(chiefs);
		});
	}, []);


	return (
		<>
			<Card style={{ marginTop: 25, marginBottom: 400 }}>
				<Row 
					style ={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
					}}
				>
					<Col xs={24} sm={12}>
						<Title level={4} style={{ color: '#0057FF', margin: '0', width: '130px', marginRight: '10px', marginBottom: '10px' }}>
							Мои заявки
						</Title>
					</Col>
					
					<Col xs={24} sm={12} style={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
						<Button
							style={{fontSize: '16px', height: '40px', width: '150px'}}
							onClick={() => navigate('/recruiting/archive')}
						>
							<FolderOpenOutlined /> Архив
						</Button>
					</Col>
				</Row>
				
				<Divider />

				<Row gutter={[7, 10]} style={{marginBottom: '15px'}}>
					<Col xs={24} sm={24} md={4} lg={4} style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
						<p style={{ marginBottom: '5px'}} >Период</p>
						<RangePicker
							style={{ height: '32px', width: '100%' }}
							format={dateFormat}
							defaultValue={[
								dayjs(firstDayOfYear, dateFormat),
								dayjs(today, dateFormat),
							]}
							onChange={handleChangeDatePicker}
						/>
					</Col>
					<Col xs={24} sm={12} md={4} lg={4} style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
						<p style={{ marginBottom: '5px'}} >Статус</p>
						<div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
							<Select
								placeholder="Выберите статус"
								value={status}
								style={{width: '90%'}}
								onChange={handleStatusChange}
								options={[
									{ value: '7621', label: 'Открыто' },
									{ value: '7622', label: 'Закрыто' },
								]}
							/>
							<div 
								className='clear-select-button'
								onClick={() => {
									setStatus('');
								}}
							>
								<CloseSquareOutlined />
							</div>
						</div>
						
					</Col>
					
					<Col xs={24} sm={12} md={5} lg={4} style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
						<p style={{ marginBottom: '5px'}} >Название вакансии</p>
						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
							<Select
								style={{width: '90%'}}
								showSearch
								placeholder="Выберите вакансию"
								value={postName}
								onChange={handlePostNameChange}
								filterOption={(input, option) =>
									(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
								}
								options={postNamesSelect}
							/>

							<div 
								className='clear-select-button'
								onClick={() => {
									setPostName('');
								}}
							>
								<CloseSquareOutlined />
							</div>
						</div>
						
					</Col>
					<Col xs={24} sm={12} md={5} lg={4} style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
						<p style={{ marginBottom: '5px'}} >Департамент</p>
						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
							<Select
								style={{width: '90%'}}
								showSearch
								placeholder="Выберите департамент"
								value={department}
								onChange={handleDepartmentChange}
								filterOption={(input, option) =>
									(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
								}
								options={departmentsSelect}
							/>
							<div 
								className='clear-select-button'
								onClick={() => {
									setDepartment('');
								}}
							>
								<CloseSquareOutlined />
							</div>
						</div>
						
					</Col>
					<Col xs={24} sm={12} md={5} lg={4} style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
						<p style={{ marginBottom: '5px'}} >Заказчик</p>
						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
							<Select
								style={{width: '90%'}}
								showSearch
								placeholder="Выберите заказчика"
								onChange={handleChiefChange}
								filterOption={(input, option) =>
									(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
								}
								value={chief}
								options={chiefSelect}
							/>
							<div 
								className='clear-select-button'
								onClick={() => {
									setChief('');
								}}
							>
								<CloseSquareOutlined />
							</div>
						</div>
						
					</Col>

					<Col xs={24} sm={24} md={12} lg={4} style={{display: 'flex', alignItems: 'flex-end'}}>
						<Button
							type='primary'
							style={{width: '100%'}}
							onClick={handleFilter}
						>
							Отфильтровать
						</Button>
					</Col>
				</Row>

				<Row style={{marginBottom: '15px'}}>
					<Col xs={24} sm={24} md={12} lg={6}>
						<Button 
							type='primary'
							style={{backgroundColor: 'green', width: '100%', height: '40px', fontSize:'16px', fontWeight: '600'}}
							onClick={downloadFile}
						>
							Выгрузить отчет
						</Button>
					</Col>
				</Row>

				<ApplicationTable
					fetchApplication={fetchApplication}
					currentPage={requestCurrentPage}
					setCurrentPage={setRequestCurrentPage}
				/>
			</Card>
		</>
	);
};

export default Submission;
